import { Injectable } from '@angular/core';
import { DataMartConstants, SalesforceConstants } from '@r1-compass-library/constants';
import { DataType } from '@r1-compass-library/models';

@Injectable({
    providedIn: 'root',
})
export class DivisionDataMappingCompatibleTypesService {
    /**
     * Maps DataMart field data types to compatible Salesforce field types
     */
    public getCompatibleSalesforceTypes(dataMartDataType: DataType): string[] {
        const normalizedType = dataMartDataType.toLowerCase();

        // Map DataMart type to Salesforce types
        if (DataMartConstants.FieldTypes.Text.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Text;
        } else if (DataMartConstants.FieldTypes.Numeric.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Numeric;
        } else if (DataMartConstants.FieldTypes.Date.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Date;
        } else if (DataMartConstants.FieldTypes.Boolean.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Boolean;
        } else {
            return [];
        }
    }

    /**
     * Get Salesforce field data types from existing Salesforce field data type
     */
    public getSalesforceTypes(salesforceDataType: string): string[] {
        const normalizedType = salesforceDataType.toLowerCase();

        //Map Salesforce type to Salesforce types
        if (SalesforceConstants.FieldTypes.Text.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Text;
        } else if (SalesforceConstants.FieldTypes.Numeric.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Numeric;
        } else if (SalesforceConstants.FieldTypes.Date.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Date;
        } else if (SalesforceConstants.FieldTypes.Boolean.includes(normalizedType)) {
            return SalesforceConstants.FieldTypes.Boolean;
        } else {
            return [];
        }
    }

    /**
     * Maps Salesforce field data types to compatible DataMart field types
     */
    public getCompatibleDataMartTypes(salesforceDataType: string): string[] {
        const normalizedType = salesforceDataType.toLowerCase();

        // Map Salesforce type to DataMart types
        if (SalesforceConstants.FieldTypes.Text.includes(normalizedType)) {
            return DataMartConstants.FieldTypes.Text;
        } else if (SalesforceConstants.FieldTypes.Numeric.includes(normalizedType)) {
            return DataMartConstants.FieldTypes.Numeric;
        } else if (SalesforceConstants.FieldTypes.Date.includes(normalizedType)) {
            return DataMartConstants.FieldTypes.Date;
        } else if (SalesforceConstants.FieldTypes.Boolean.includes(normalizedType)) {
            return DataMartConstants.FieldTypes.Boolean;
        } else {
            return [];
        }
    }

    public getCompatibleDefinedFieldTypes(salesforceDataType: string): string[] {
        const normalizedType = salesforceDataType.toLowerCase();

        if (SalesforceConstants.FieldTypes.Text.includes(normalizedType)) {
            return ['varchar', 'picklist'];
        } else if (SalesforceConstants.FieldTypes.Numeric.includes(normalizedType)) {
            return ['number', 'picklist'];
        } else if (SalesforceConstants.FieldTypes.Date.includes(normalizedType)) {
            return ['date'];
        } else if (SalesforceConstants.FieldTypes.Boolean.includes(normalizedType)) {
            return ['boolean'];
        } else {
            return [];
        }
    }
}
